/**
 * CRM Multi-Compagnia · Lista batch SIA storica + dettaglio modal
 */
import { useState } from "react";
import { History, FileText, Download } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, Modal, Btn, Select, fmtDateTime
} from "@/components/crm-multi/shared";

export default function SiaBatchesPage() {
  const [tipo, setTipo] = useState("");
  const [stato, setStato] = useState("");
  const list = useApi(() => api.get("/sia/batches", { limit: 100 }));
  const [selected, setSelected] = useState(null);

  const filtered = (list.data?.items || []).filter(b =>
    (!tipo || b.tipo_import === tipo) && (!stato || b.stato === stato)
  );

  return (
    <div className="space-y-4" data-testid="sia-batches-page">
      <header className="flex justify-between items-center gap-3 flex-wrap">
        <div>
          <h2 className="text-lg font-semibold flex items-center gap-2"><History className="w-5 h-5" /> Storico batch SIA</h2>
          <p className="text-sm text-zinc-500">{list.data?.total ?? 0} batch totali</p>
        </div>
        <div className="flex gap-2">
          <Select value={tipo} onChange={(e) => setTipo(e.target.value)} className="w-44">
            <option value="">Tutti i tipi</option>
            <option value="clienti">Clienti</option><option value="compagnie">Compagnie</option>
            <option value="prodotti">Prodotti</option><option value="polizze">Polizze</option>
            <option value="sinistri">Sinistri</option><option value="incassi">Incassi</option>
          </Select>
          <Select value={stato} onChange={(e) => setStato(e.target.value)} className="w-44">
            <option value="">Tutti gli stati</option>
            <option value="uploaded">Uploaded</option><option value="mapped">Mapped</option>
            <option value="simulated">Simulated</option><option value="completed">Completed</option>
            <option value="fallito">Fallito</option>
          </Select>
        </div>
      </header>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="sia-batches-table"
          onRowClick={setSelected}
          columns={[
            { key: "id", label: "ID", render: r => <code className="text-xs">{r.id?.slice(0, 8)}</code> },
            { key: "nome_file", label: "File", render: r => <span className="text-xs font-mono">{r.nome_file || "—"}</span> },
            { key: "tipo_import", label: "Tipo", render: r => <span className="text-xs capitalize">{r.tipo_import}</span> },
            { key: "righe_totali", label: "Righe", render: r => r.righe_totali },
            { key: "stato", label: "Stato", render: r => {
              const cls = r.stato === "completed" ? "bg-emerald-100 text-emerald-800" : r.stato === "fallito" ? "bg-rose-100 text-rose-800" : "bg-amber-100 text-amber-800";
              return <span className={`px-2 py-0.5 rounded text-xs ${cls}`}>{r.stato}</span>;
            }},
            { key: "righe_ok", label: "OK", render: r => <span className="text-emerald-700">{r.righe_ok}</span> },
            { key: "righe_errore", label: "Err.", render: r => <span className="text-rose-700">{r.righe_errore}</span> },
            { key: "righe_duplicate", label: "Dup.", render: r => <span className="text-amber-700">{r.righe_duplicate}</span> },
            { key: "started_at", label: "Avviato", render: r => <span className="text-xs">{fmtDateTime(r.started_at)}</span> },
          ]}
          rows={filtered}
          emptyTitle="Nessun batch"
        />
      )}

      <Modal open={!!selected} onClose={() => setSelected(null)}
              title={`Batch ${selected?.id?.slice(0, 8)} · ${selected?.tipo_import}`}
              maxWidth="max-w-3xl" testid="sia-batch-detail">
        {selected && (
          <div className="space-y-3">
            <pre className="bg-zinc-50 p-3 rounded text-xs overflow-auto max-h-96">{JSON.stringify(selected.report_json?.summary, null, 2)}</pre>
            <div className="flex gap-2 flex-wrap">
              <Btn variant="outline" size="sm" onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/admin/crm/multi/sia/batches/${selected.id}/report.pdf`, "_blank")}><FileText className="w-3.5 h-3.5" /> PDF</Btn>
              <Btn variant="outline" size="sm" onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/admin/crm/multi/sia/batches/${selected.id}/report.xlsx`, "_blank")}><Download className="w-3.5 h-3.5" /> Excel</Btn>
              {selected.righe_errore > 0 && <Btn variant="outline" size="sm" onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/admin/crm/multi/sia/batches/${selected.id}/errors.csv`, "_blank")}><Download className="w-3.5 h-3.5" /> Errori CSV</Btn>}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
